import React from "react";
import "./services.css";
import { useTranslation } from "../../hooks/translation";

interface ServicesProps {
  lang: string;
}

export const Services: React.FC<ServicesProps> = ({ lang }) => {
  const { t } = useTranslation(lang);

  return (
    <section id="services" className="section">
      <hr />
      <div className="container">
        <h1>{t("services.title")}</h1>

        <div className="service-cards">

          {/* 1. Strategy */}
          <div className="service-card">
            <div className="text">
              <div className="text-top">
                <h3>{t("services.strategy.title")}</h3>
                <div className="icon">
                  <img src="/img/icons/data-points-bars.png" alt="..." />
                </div>
              </div>
              <div className="text-body">
                <p>
                  <b>{t("services.strategy.bold")}</b> {t("services.strategy.body")}
                </p>
                <ul>
                  <li>{t("services.strategy.points.1")}</li>
                  <li>{t("services.strategy.points.2")}</li>
                  <li>{t("services.strategy.points.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 2. R&D */}
          <div className="service-card">
            <div className="text">
              <div className="text-top">
                <h3>{t("services.rd.title")}</h3>
                <div className="icon">
                  <img src="/img/icons/analysis.png" alt="Analysis" />
                </div>
              </div>
              <div className="text-body">
                <p>
                  <b>{t("services.rd.bold")}</b> {t("services.rd.body")}
                </p>
                <ul>
                  <li>{t("services.rd.points.1")}</li>
                  <li>{t("services.rd.points.2")}</li>
                  <li>{t("services.rd.points.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 3. Validation */}
          <div className="service-card">
            <div className="text">
              <div className="text-top">
                <h3>{t("services.validation.title")}</h3>
                <div className="icon">
                  <img src="/img/icons/connected-dots.png" alt="I+D" />
                </div>
              </div>
              <div className="text-body">
                <p>
                  <b>{t("services.validation.bold")}</b> {t("services.validation.body")}
                </p>
                <ul>
                  <li>{t("services.validation.points.1")}</li>
                  <li>{t("services.validation.points.2")}</li>
                  <li>{t("services.validation.points.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 4. Custom Dev */}
          <div className="service-card">
            <div className="text">
              <div className="text-top">
                <h3>{t("services.custom.title")}</h3>
                <div className="icon">
                  <img src="/img/icons/custom-software.png" alt="Custom Software Development" />
                </div>
              </div>
              <div className="text-body">
                <p>
                  <b>{t("services.custom.bold")}</b> {t("services.custom.body")}
                </p>
                <ul>
                  <li>{t("services.custom.points.1")}</li>
                  <li>{t("services.custom.points.2")}</li>
                  <li>{t("services.custom.points.3")}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 5. Integration */}
          <div className="service-card">
            <div className="text">
              <div className="text-top">
                <h3>{t("services.integration.title")}</h3>
                <div className="icon">
                  <img src="/img/icons/technology.png" alt="Technology" />
                </div>
              </div>
              <div className="text-body">
                <p>
                  <b>{t("services.integration.bold")}</b> {t("services.integration.body")}
                </p>
                <ul>
                  <li>{t("services.integration.points.1")}</li>
                  <li>{t("services.integration.points.2")}</li>
                  <li>{t("services.integration.points.3")}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
